import { ResponseError } from 'superagent';

export const isApiError = (error: unknown): error is ResponseError => {
  return typeof error === 'object' && error !== null && 'status' in error;
};
